/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemTileCarousel_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_user">;
    readonly " $refType": "PdpRespSimilarItemTileCarousel_user";
};
export type PdpRespSimilarItemTileCarousel_user$data = PdpRespSimilarItemTileCarousel_user;
export type PdpRespSimilarItemTileCarousel_user$key = {
    readonly " $data"?: PdpRespSimilarItemTileCarousel_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemTileCarousel_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemTileCarousel_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_user",
      "args": null
    }
  ]
};
(node as any).hash = 'b9a3b17243d2a465019cbba29af6bebd';
export default node;
